import {TreeNode} from "primeng/api";
import {AbstractControl, FormGroup} from "@angular/forms";
import {addMonths, eachWeekOfInterval, format} from "date-fns";

export class Helper{

  buildURLSearchParams(filters: any): URLSearchParams {
    if(!filters || typeof filters !== 'object') {
      filters = {};
    }
    let keys = Object.keys(filters);
    let queryParams = new URLSearchParams();
    for (const key of keys) {
      if (filters[key]) {
        queryParams.append(key, filters[key]);
      }
    }
    return queryParams;
  }
  formatDate(date: string): string {
    //use intl to format the date
    return new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true}).format(new Date(date));
  }

  mapNestedArrayToTree(data: any[], sortBy: string = '', sortOrder: 'asc' | 'desc' = 'asc', parentId?: string): TreeNode[] {
    // Initialize an empty array to store the mapped values
    const mappedValues: TreeNode[] = [];

    // Iterate over each item
    data.forEach(sdl => {
      let node: TreeNode = {
        data: {
          name: sdl.name,
          week1: '',
          week2: '',
          week3: '',
          week4: ''
        },
        children: []
      };

      // Add projects to the children
      sdl.projects.forEach((project: any) => {
        let projectNode: TreeNode = {
          data: {
            name: project.name,
            week1: project.hours[0].value,
            week2: project.hours[1].value,
            week3: project.hours[2].value,
            week4: project.hours[3].value
          },
          children: []
        };

        // Sum up resource hours for each week
        let projectTotals = {
          week1: 0,
          week2: 0,
          week3: 0,
          week4: 0
        };

        let SDLTotals = {
          week1: 0,
          week2: 0,
          week3: 0,
          week4: 0
        }
        
        project.resources.forEach((resource: any) => {
          let resourceNode: TreeNode = {
            data: {
              name: resource.name,
              week1: resource.hours[0] ? { hours: resource.hours[0].value, billType: resource.allocations[0]?.billType } : { hours: 0, billType: null },
              week2: resource.hours[1] ? { hours: resource.hours[1].value, billType: resource.allocations[1]?.billType } : { hours: 0, billType: null },
              week3: resource.hours[2] ? { hours: resource.hours[2].value, billType: resource.allocations[2]?.billType } : { hours: 0, billType: null },
              week4: resource.hours[3] ? { hours: resource.hours[3].value, billType: resource.allocations[3]?.billType } : { hours: 0, billType: null },
            }
          };

        // Sum up hours for each week
        projectTotals.week1 += parseFloat(resource.hours[0]?.value || 0);
        projectTotals.week2 += parseFloat(resource.hours[1]?.value || 0);
        projectTotals.week3 += parseFloat(resource.hours[2]?.value || 0);
        projectTotals.week4 += parseFloat(resource.hours[3]?.value || 0);

          // @ts-ignore
          projectNode.children.push(resourceNode);
        });

        // Update project node with totals
      
        projectNode.data.week1 = projectTotals.week1;
        projectNode.data.week2 = projectTotals.week2;
        projectNode.data.week3 = projectTotals.week3;
        projectNode.data.week4 = projectTotals.week4;

        // Add to SDL totals
        SDLTotals.week1 += projectTotals.week1;
        SDLTotals.week2 += projectTotals.week2;
        SDLTotals.week3 += projectTotals.week3;
        SDLTotals.week4 += projectTotals.week4;

        SDLTotals.week1 > 0? node.data.week1 = SDLTotals.week1 : '';
        SDLTotals.week2 > 0? node.data.week2 = SDLTotals.week2 : '';
        SDLTotals.week3 > 0? node.data.week3 = SDLTotals.week3 : '';
        SDLTotals.week4 > 0? node.data.week4 = SDLTotals.week4 : '';
        //console.table([projectNode.data.week1, projectNode.data.week2, projectNode.data.week3, projectNode.data.week4])
        // @ts-ignore
        node.children.push(projectNode);
      });

      mappedValues.push(node);
    });
    return mappedValues;
  }
  
  groupPermissions(permissions:any[]){
    permissions.sort((a, b) => a.group?.localeCompare(b.group));
    return permissions?.reduce((groups, permission) => {
      (groups[permission.group] = groups[permission.group] || []).push(permission);
      return groups;
    }, {});
  }
  getBillTypeInfo(billType: number): { class: string; tooltip: string, name:string, } {
    switch (billType) {
      case 5:
        return { class: 'billable', tooltip: 'billable', name:'Billable' };
      case 6:
        return { class: 'non-billable', tooltip: 'non-billable', name:'Non-billable' };
      case 7:
        return { class: 'internal', tooltip: 'internal', name:"Internal" };
      default:
        return { class: 'C', tooltip: 'Unallocated hours', name:"Unassigned" };
    }
  }
  checkUnassignedBillType(billType:string){
    switch(billType){
      case null:
      return {class: "Unassigned", name: "Unallocated hours"}
      case undefined:
      return {class: "Unassigned", name:"Unallocated hours"}
      default:
        return {class: billType, name: billType}
    }
  }
  markFormControlsAsTouched(formGroup: FormGroup | AbstractControl) {
    if (formGroup instanceof FormGroup) {
      Object.values(formGroup.controls).forEach(control => {
        if (control instanceof FormGroup) {
          this.markFormControlsAsTouched(control);
        } else {
          control.markAsTouched();
        }
      });
    } else {
      formGroup.markAsTouched();
    }
  }
  getMondays12WeeksOut() {
    const today = new Date();
    const twelveWeeksLater = addMonths(today, 3);
    const allMondayDTM = eachWeekOfInterval(
      {start: today, end: twelveWeeksLater},
      {weekStartsOn: 1},
    );
    return allMondayDTM.map((monday: any) => {
      return {
        label: format(monday, 'MMM dd'),
        value: format(monday, 'yyyy-MM-dd'),
      };
    });
  }
  getFridayOfTheWeek(date: Date){
    let dateObj = new Date(date);
    let dayOfWeek = dateObj.getDay();
    let daysToAdd = 5 - dayOfWeek;
    dateObj.setDate(dateObj.getDate() + daysToAdd);
    dateObj.setHours(0, 0, 0, 0);
    return new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()));
  }
}
